<template>
    <div>
    <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page.sync="page"
                   v-model="form"
                   ref="crud"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @on-load="onLoad"
                   @refresh-change="onLoad"
        >
    </avue-crud>
    </div>
</template>

<script>
  import {
  getAccountSearch,getSubjectList,getFavouredPolicy
} from '@/api/charge/charge-pay';
import { getDictionaryWithIntKey } from '../../../api/common';
import { getDictionary } from '../../../api/common';
    export default {
         data() {
        return {
            loading: true,
            query: {
            communityId:''
            },
            form:{},
            data:[],
            option:{
                    height: '500',
                    calcHeight: 500,
                    tip: false,
                    border: true,
                    index: true,
                    indexLabel: "序号",
                    addBtn:false,
                    viewBtn: false,
                    selection: false,
                    menu:false,
                     column:[
                         {
                                    label: "小区名称",
                                    prop: "communityName",

                        },
                         {
                                    label: "减免名称",
                                    prop: "name",

                        },
                        {
                                    label: "减免范围",
                                    prop: "scope",

                        },
                        {
                                    label: "减免详情",
                                    prop: "sceneAndDerate",

                        },
                        {
                                    label: "生效时间",
                                    prop: "useTime",

                        },
                        {
                                    label: "失效时间",
                                    prop: "stopTime",


                        },

                     ]
            },
            page: {
                pageSize: 10,
                currentPage: 1,
                total: 0
            },
        }
      },
     mounted() {
         this.initSelectList();
     },
     methods:{
         //表格清空
        restTable(){
          //数据清空
          this.data = []
          //分页清空
          this.page.total = 0
        },
        search(val){
            this.query.communityId = val
             this.onLoad();
        },
        initSelectList() {

        },
        currentChange(currentPage) {
            this.page.currentPage = currentPage;
        },
        sizeChange(pageSize) {
            this.page.pageSize = pageSize;
        },
        onLoad(page) {
            page = page || this.page;
            this.loading = true;
            console.log('出发了')
            getFavouredPolicy(
                  Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
              ).then(({data}) => {
                  this.page.total = data.total;
                  this.data = data.records;
                  this.loading = false;
                  this.selectionClear();
            });
            this.loading = false
        }
     }
    }
  </script>

<style scoped >

</style>
